import React, { Component } from 'react'
import { observer } from 'mobx-react'
import EmptyIcon from '@components/Icon/Empty'

class NoContent extends Component {
  render () {
    return (
      <div className='no-content-wrapper'>
        <div className='no-content-wrapper__center'>
          <EmptyIcon />
          <div>{this.props.label}</div>
          <div className='no-content-wrapper__action'>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default observer(NoContent)
